import { createAction } from '@reduxjs/toolkit';
export const REFRESH_TOKEN = 'REFRESH_TOKEN';
export const refreshTokenAction = createAction(REFRESH_TOKEN);